<template>
  <div class="text-left w-full" :class="data.spacing" v-if="data.model">
    <p class="mb-2 font-bold whitespace-pre-line">
      {{ data.model.questionText }}
      <span v-if="data.model.mandatory && !data.isChildQuestion" class="text-red-500">*</span>
    </p>
    <label :for="data.model.id" class="block mb-4">{{ data.model.helperText }}</label>

    <AutoComplete
      @geocode="onGeocode($event)"
      @autocompleted="onAutocomplete($event)"
      inputclass="inlineErrorInput"
      :placeholder="data.model.placeholderText"
      :isplaces="true"
      :formname="data.model.id"
      v-model="data.answer"
    />
  </div>
</template>

<script lang="ts" setup>
import { reactive, watch, onMounted } from 'vue';
import AutoComplete from '../../../components/AutoComplete.vue';

import { QuestionModel } from '../types';
const props = defineProps<{
  question: QuestionModel;
  isChildQuestion?: boolean;
  multiQuestion?: boolean;
}>();
const emit = defineEmits(['answerChanged']);

const data = reactive({
  model: props.question,
  locationText: '',
  answer: '',
  spacing: 'mb-16',
  isChildQuestion: props.isChildQuestion,
});

onMounted(() => {
  if (props.isChildQuestion) data.spacing = 'mb-8';
  if (props.multiQuestion) data.spacing = 'mb-4';
});

watch(
  () => data.answer,
  () => {
    emit('answerChanged', {
      id: data.model.id,
      answer: data.answer,
    });
  },
);

const onGeocode = (e) => {
  // Catch emit from autocomplete component and set to model
  data.locationText = e;
};

const onAutocomplete = (e) => {
  if (e === null) {
    // The user just deleted their answer
    data.locationText = '';
    data.answer = e;
    return;
  }

  if (typeof e === 'string') {
    data.locationText = e;
    data.answer = e;
    return;
  }

  const { Address, Latitude, Longitude } = e;
  data.locationText = Address;
  data.answer = `${Address} {${Latitude.toFixed(4)},${Longitude.toFixed(4)}}`;
};
</script>
